var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66634 8.33327L3.71611 12.5323C3.74563 12.6504 3.76039 12.7095 3.77785 12.761C3.94845 13.2647 4.40202 13.6188 4.93202 13.6622C4.98628 13.6666 5.04714 13.6666 5.16887 13.6666C5.3213 13.6666 5.39752 13.6666 5.46173 13.6604C6.09634 13.5988 6.59856 13.0966 6.66012 12.462C6.66634 12.3978 6.66634 12.3216 6.66634 12.1691V2.66661M12.333 7.99994C13.6217 7.99994 14.6663 6.95527 14.6663 5.66661C14.6663 4.37794 13.6217 3.33327 12.333 3.33327M6.83301 2.66661H4.33301C2.67615 2.66661 1.33301 4.00975 1.33301 5.66661C1.33301 7.32346 2.67615 8.66661 4.33301 8.66661H6.83301C8.01063 8.66661 9.45117 9.29787 10.5625 9.9037C11.2109 10.2571 11.5351 10.4339 11.7474 10.4079C11.9443 10.3837 12.0931 10.2953 12.2086 10.134C12.333 9.96004 12.333 9.61194 12.333 8.91575V2.41746C12.333 1.72127 12.333 1.37317 12.2086 1.1992C12.0931 1.03788 11.9443 0.949474 11.7474 0.92536C11.5351 0.899356 11.2109 1.07607 10.5625 1.42951C9.45117 2.03535 8.01062 2.66661 6.83301 2.66661Z",
    stroke: "#7E5435",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.8abe5b10a98a0cfcb51bcb09918d588b.svg";
export { ForwardRef as ReactComponent };